<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 背景装饰 -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden">
      <div class="absolute top-20 left-10 w-32 h-32 bg-psychology-primary-20 rounded-full blur-xl"></div>
      <div class="absolute top-40 right-16 w-24 h-24 bg-yellow-200/20 rounded-full blur-lg"></div>
      <div class="absolute bottom-32 left-1/3 w-40 h-40 bg-orange-200/20 rounded-full blur-xl"></div>
    </div>

    <!-- 导航栏 -->
    <NavBar />

    <!-- 主要内容 -->
    <div class="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <!-- 页面标题 -->
      <div class="text-center mb-12">
        <div class="text-6xl mb-6">🦊</div>
        <h1 class="text-4xl font-bold text-gray-900 mb-4">使用指南</h1>
        <p class="text-xl text-gray-600 max-w-2xl mx-auto">
          通过60道有趣的选择题，找出最符合你性格的动物原型
        </p>
      </div>

      <div class="space-y-8">
        <!-- 快速开始 -->
        <div class="card">
          <div class="p-6">
            <div class="text-2xl font-semibold flex items-center gap-3 mb-6">
              <span class="text-3xl">🚀</span>
              <span>快速开始</span>
            </div>
            
            <div class="bg-gradient-to-r from-psychology-calm to-psychology-warm rounded-lg p-6 border border-psychology-primary-20">
              <div class="space-y-4">
                <div class="flex items-center gap-3">
                  <div class="inline-flex items-center rounded-full border px-3 py-1 text-sm font-semibold bg-psychology-primary-10 text-psychology-primary border-psychology-primary-20">
                    ⏱️ 预计耗时
                  </div>
                  <span class="text-gray-700">5-8 分钟</span>
                </div>
                <div class="flex items-center gap-3">
                  <div class="inline-flex items-center rounded-full border px-3 py-1 text-sm font-semibold bg-yellow-100 text-yellow-700 border-yellow-200">
                    📝 题目数量
                  </div>
                  <span class="text-gray-700">60 道选择题</span>
                </div>
                <div class="flex items-center gap-3">
                  <div class="inline-flex items-center rounded-full border px-3 py-1 text-sm font-semibold bg-psychology-primary-10 text-psychology-primary border-psychology-primary-20">
                    🎯 测试结果
                  </div>
                  <span class="text-gray-700">匹配25种动物原型之一</span>
                </div>
                <div class="flex items-center gap-3">
                  <div class="inline-flex items-center rounded-full border px-3 py-1 text-sm font-semibold bg-pink-100 text-pink-700 border-pink-200">
                    💡 答题方式
                  </div>
                  <span class="text-gray-700">凭第一感觉选择，无需过度思考</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 测评流程 -->
        <div class="card">
          <div class="p-6">
            <div class="text-2xl font-semibold flex items-center gap-3 mb-6">
              <span class="text-3xl">📋</span>
              <span>测试流程</span>
            </div>

            <div class="space-y-4">
              <!-- 步骤1 -->
              <div class="flex items-start gap-4 p-4 bg-psychology-primary-10 rounded-lg border border-psychology-primary-20">
                <div class="flex-shrink-0 w-10 h-10 bg-gradient-to-r from-psychology-primary to-psychology-secondary text-white rounded-full flex items-center justify-center text-lg font-semibold">
                  1
                </div>
                <div class="flex-1">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-2xl">📝</span>
                    <h4 class="font-semibold text-gray-900">开始测试</h4>
                  </div>
                  <p class="text-sm text-gray-600">点击"开始测试"按钮，阅读简单的测试说明</p>
                </div>
              </div>

              <!-- 步骤2 -->
              <div class="flex items-start gap-4 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                <div class="flex-shrink-0 w-10 h-10 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-full flex items-center justify-center text-lg font-semibold">
                  2
                </div>
                <div class="flex-1">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-2xl">👤</span>
                    <h4 class="font-semibold text-gray-900">基本信息（选填）</h4>
                  </div>
                  <p class="text-sm text-gray-600">可以填写昵称和性别，也可以直接跳过</p>
                </div>
              </div>

              <!-- 步骤3 -->
              <div class="flex items-start gap-4 p-4 bg-psychology-primary-10 rounded-lg border border-psychology-primary-20">
                <div class="flex-shrink-0 w-10 h-10 bg-gradient-to-r from-psychology-primary to-psychology-info text-white rounded-full flex items-center justify-center text-lg font-semibold">
                  3
                </div>
                <div class="flex-1">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-2xl">✍️</span>
                    <h4 class="font-semibold text-gray-900">答题</h4>
                  </div>
                  <p class="text-sm text-gray-600">根据第一感觉回答60道选择题，每题有A/B/C/D四个选项</p>
                </div>
              </div>

              <!-- 步骤4 -->
              <div class="flex items-start gap-4 p-4 bg-pink-50 rounded-lg border border-pink-200">
                <div class="flex-shrink-0 w-10 h-10 bg-gradient-to-r from-pink-600 to-purple-600 text-white rounded-full flex items-center justify-center text-lg font-semibold">
                  4
                </div>
                <div class="flex-1">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-2xl">🔍</span>
                    <h4 class="font-semibold text-gray-900">查看结果</h4>
                  </div>
                  <p class="text-sm text-gray-600">系统会匹配出最符合你的动物原型，并显示详细的性格分析</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 答题建议 -->
        <div class="card">
          <div class="p-6">
            <div class="text-2xl font-semibold flex items-center gap-3 mb-6">
              <span class="text-3xl">💡</span>
              <span>答题建议</span>
            </div>

            <div class="grid gap-4">
              <div class="flex items-start gap-3 p-4 border border-purple-200 rounded-lg bg-purple-50/50">
                <span class="text-2xl">✨</span>
                <div>
                  <h4 class="font-medium text-gray-900 mb-1">相信第一感觉</h4>
                  <p class="text-sm text-gray-600">不要过度思考，快速选择最符合你直觉的选项</p>
                </div>
              </div>

              <div class="flex items-start gap-3 p-4 border border-psychology-info-20 rounded-lg bg-psychology-info-10">
                <span class="text-2xl">🎭</span>
                <div>
                  <h4 class="font-medium text-gray-900 mb-1">诚实作答</h4>
                  <p class="text-sm text-gray-600">选择最符合你真实性格的选项，没有对错之分</p>
                </div>
              </div>

              <div class="flex items-start gap-3 p-4 border border-psychology-primary-20 rounded-lg bg-psychology-primary-10">
                <span class="text-2xl">⏱️</span>
                <div>
                  <h4 class="font-medium text-gray-900 mb-1">保持专注</h4>
                  <p class="text-sm text-gray-600">在安静、不被打扰的环境中完成测试，确保可以专注思考</p>
                </div>
              </div>

              <div class="flex items-start gap-3 p-4 border border-pink-200 rounded-lg bg-pink-50/50">
                <span class="text-2xl">🔄</span>
                <div>
                  <h4 class="font-medium text-gray-900 mb-1">可以返回修改</h4>
                  <p class="text-sm text-gray-600">答题过程中可以返回上一题修改答案，进度会自动保存</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 测试说明 -->
        <div class="card border-yellow-200 bg-yellow-50/30">
          <div class="p-6">
            <div class="text-2xl font-semibold flex items-center gap-3 mb-6 text-yellow-800">
              <span class="text-3xl">⚠️</span>
              <span>重要说明</span>
            </div>

            <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <div class="space-y-3 text-sm">
                <div class="flex items-start gap-2">
                  <span class="text-yellow-600 mt-1">•</span>
                  <span class="text-gray-700"><strong>趣味测试：</strong>这是一个有趣的性格测试，仅供娱乐和自我了解，不能替代专业的心理评估</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-yellow-600 mt-1">•</span>
                  <span class="text-gray-700"><strong>隐私保护：</strong>所有数据仅存储在您的设备本地，不会上传到任何服务器</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-yellow-600 mt-1">•</span>
                  <span class="text-gray-700"><strong>结果解读：</strong>测试结果基于7个维度的相似度匹配，每个人都是独特的，结果仅供参考</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-yellow-600 mt-1">•</span>
                  <span class="text-gray-700"><strong>多次测试：</strong>可以多次测试，不同时间、不同心情可能会得到不同的结果</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 结果解读 -->
        <div class="card">
          <div class="p-6">
            <div class="text-2xl font-semibold flex items-center gap-3 mb-6">
              <span class="text-3xl">🎯</span>
              <span>结果解读</span>
            </div>

            <div class="space-y-6">
              <!-- 25种动物 -->
              <div>
                <h4 class="font-semibold text-gray-900 mb-3">25种动物原型</h4>
                <p class="text-sm text-gray-600 mb-3">测试会从25种动物中匹配出最符合你性格的动物原型，包括：</p>
                <div class="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-10 gap-2 text-sm">
                  <div class="text-center p-2 bg-gray-50 rounded">🐶 狗</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐱 猫</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐺 狼</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦊 狐</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦁 狮</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐻 熊</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐰 兔</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐹 仓鼠</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐷 猪</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦢 天鹅</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦋 蝴蝶</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦌 鹿</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦅 鹰</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐦‍⬛ 乌鸦</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦫 水豚</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦟 蚊子</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐋 鲸</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦜 鹦鹉</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐙 章鱼</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦈 鲨鱼</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🐬 海豚</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🪳 蟑螂</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦝 浣熊</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦨 猫鼬</div>
                  <div class="text-center p-2 bg-gray-50 rounded">🦙 草泥马</div>
                </div>
              </div>

              <div class="border-t border-gray-200 my-4"></div>

              <!-- 7个维度 -->
              <div>
                <h4 class="font-semibold text-gray-900 mb-3">7个性格维度</h4>
                <p class="text-sm text-gray-600 mb-3">测试通过以下7个维度来分析你的性格特征：</p>
                <div class="grid md:grid-cols-2 gap-3 text-sm">
                  <div class="p-3 bg-purple-50 rounded border border-purple-200">
                    <div class="font-medium text-gray-900 mb-1">支配性 (DOM)</div>
                    <div class="text-gray-600 text-xs">领导力、控制欲、统御能力</div>
                  </div>
                  <div class="p-3 bg-psychology-info-10 rounded border border-psychology-info-20">
                    <div class="font-medium text-gray-900 mb-1">策略性 (STR)</div>
                    <div class="text-gray-600 text-xs">智慧、谋略、解决问题的能力</div>
                  </div>
                  <div class="p-3 bg-psychology-primary-10 rounded border border-psychology-primary-20">
                    <div class="font-medium text-gray-900 mb-1">社群性 (COM)</div>
                    <div class="text-gray-600 text-xs">社交能力、团队合作、归属感</div>
                  </div>
                  <div class="p-3 bg-yellow-50 rounded border border-yellow-200">
                    <div class="font-medium text-gray-900 mb-1">独处性 (SOL)</div>
                    <div class="text-gray-600 text-xs">独立性、享受独处、自我满足</div>
                  </div>
                  <div class="p-3 bg-pink-50 rounded border border-pink-200">
                    <div class="font-medium text-gray-900 mb-1">敏捷性 (AGI)</div>
                    <div class="text-gray-600 text-xs">灵活性、适应性、反应速度</div>
                  </div>
                  <div class="p-3 bg-indigo-50 rounded border border-indigo-200">
                    <div class="font-medium text-gray-900 mb-1">安全性 (SEC)</div>
                    <div class="text-gray-600 text-xs">安全感需求、稳定性、警惕性</div>
                  </div>
                  <div class="p-3 bg-rose-50 rounded border border-rose-200">
                    <div class="font-medium text-gray-900 mb-1">美学性 (AES)</div>
                    <div class="text-gray-600 text-xs">对美的追求、优雅、理想主义</div>
                  </div>
                </div>
              </div>

              <div class="border-t border-gray-200 my-4"></div>

              <!-- 结果内容 -->
              <div>
                <h4 class="font-semibold text-gray-900 mb-3">结果包含</h4>
                <div class="space-y-2 text-sm text-gray-600">
                  <div class="flex items-center gap-2">
                    <span class="text-purple-600">✓</span>
                    <span>匹配的动物原型及相似度</span>
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="text-psychology-info">✓</span>
                    <span>详细的性格描述和特征标签</span>
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="text-psychology-primary">✓</span>
                    <span>适合的职业建议</span>
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="text-pink-600">✓</span>
                    <span>与其他动物的相性分析</span>
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="text-yellow-600">✓</span>
                    <span>你的7维度分数分布</span>
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="text-indigo-600">✓</span>
                    <span>所有25种动物的匹配度排名</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CTA按钮 -->
        <div class="max-w-3xl mx-auto bg-gradient-to-r from-psychology-primary to-psychology-secondary rounded-3xl p-12 text-white shadow-2xl">
          <div class="text-center">
            <div class="text-6xl mb-6">🎯</div>
            <h3 class="text-4xl font-bold mb-4">准备发现你的动物原型了吗？</h3>
            <p class="text-lg mb-8 opacity-90 max-w-2xl mx-auto">
              通过科学的七维度性格模型，找到最能代表你的动物形象，深入了解真实的自己
            </p>
            <router-link
              to="/assessment/start"
              class="inline-flex items-center gap-2 px-8 py-4 bg-white text-psychology-primary rounded-lg font-bold text-lg hover:bg-gray-100 transition-all hover:shadow-xl"
            >
              <span class="text-2xl">🦊</span>
              <span>开始测试</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 回到顶部 -->
    <BackToTop />
  </div>
</template>

<script setup>
import NavBar from '../components/NavBar.vue'
import BackToTop from '../components/BackToTop.vue'
</script>

<style scoped>
.card {
  @apply bg-white rounded-xl shadow-md border border-gray-200;
}
</style>